import dayjs from "dayjs";
import { REGEX_EXPS } from "utils/constants";
import {
  createContractNumberValidation,
  normalizeTextField,
} from "utils/helpers/validations";
import * as yup from "yup";

const validator = (
  messages,
  { deltaRia, deltaStart, deltaEndRia, deltaEnd },
) => {
  const contractNumber = createContractNumberValidation(messages, REGEX_EXPS);
  const requiredDate = yup
    .date()
    .transform((_, originalValue) => {
      const parsed = dayjs(originalValue);
      return parsed.isValid() ? parsed.toDate() : originalValue;
    })
    .typeError(messages.REQUIRED)
    .required(messages.REQUIRED);

  return yup.object().shape({
    ria: yup.boolean(),
    contract: yup.object().shape({
      issuanceDate: requiredDate,
    }),
    fields: yup.object().shape({
      familyStatus: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      birthCountry: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      birthDepartment: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      profession: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      professionalSituation: yup
        .string()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED)
        .nullable(),
      hasExistingContract: yup.boolean(),
      contractMoreThanOneYear: yup.boolean(),
      selfOccupation: yup.boolean().nullable(),
      isPPE: yup.boolean(),
      ppeFunction: yup.string().when("isPPE", {
        is: true,
        then: yup
          .string()
          .transform(normalizeTextField)
          .typeError(messages.REQUIRED)
          .required(messages.REQUIRED),
        otherwise: yup
          .string()
          .transform(normalizeTextField)
          .typeError(messages.REQUIRED)
          .nullable(),
      }),
      ppeRelated: yup
        .boolean()
        .typeError(messages.REQUIRED)
        .required(messages.REQUIRED),
      phoneCanvassing: yup.boolean(),
      phoneCanvassingConsent: yup.boolean().when("phoneCanvassing", {
        is: true,
        then: yup
          .boolean()
          .oneOf([true], messages.REQUIRED)
          .required(messages.REQUIRED),
      }),
    }),
    terminationRequest: yup.mixed().when(
      [
        "ria",
        "fields.hasExistingContract",
        "fields.contractMoreThanOneYear",
        "fields.selfOccupation",
      ],
      {
        is: (
          ria,
          hasExistingContract,
          contractMoreThanOneYear,
          selfOccupation,
        ) =>
          (hasExistingContract || ria) &&
          contractMoreThanOneYear === true &&
          selfOccupation === false,
        then: () =>
          yup
            .object()
            .typeError(messages.REQUIRED)
            .shape({
              contractNumber,
              dueDate: yup
                .date()
                .typeError(messages.REQUIRED)
                .required(messages.REQUIRED)
                .test("dueDateFormat", messages.INVALID_DUE_DATE, (value) => {
                  return (
                    dayjs(value).isValid() &&
                    dayjs(value).isBefore(dayjs().subtract(1, "year"))
                  );
                }),
              recipient: yup
                .string()
                .typeError(messages.REQUIRED)
                .required(messages.REQUIRED),
              reason: yup
                .string()
                .typeError(messages.REQUIRED)
                .required(messages.REQUIRED),
            }),
        otherwise: () => yup.mixed().nullable().notRequired(),
      },
    ),
  });
};

export default validator;
